import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {api} from "../../maps/data.js";
import PageTitle from "../../components/PageTitle";
import Icn from "../../components/Icn";
import Tx from "../../components/Tx";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import {getQueryValue} from "../../domain/queryHandler";
import {register, unregister} from "../../domain/socketSlice";
import useInfiniteScroll from 'react-infinite-scroll-hook';
import SiteAdminAlerts from "../../components/alerts/SiteAdminAlerts";
import {
    ActionItemStyled,
    ActionsWrapperStyled, GROUND_TRUTH_DATA,
    ListWrapperStyled,
    TitleWrapperStyled,
    WrapperStyled
} from "../../components/alerts/CommonStyles";
import AlertManager from "../../components/alerts/AlertManager";
import useZibi from "../../zibi/UseZibi";
import {USER_TYPES} from "../../maps/permissionsMap";
import ALERT_MAP from "../../maps/alertMap";

const AlertsPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const sev = getQueryValue(location, 'sev');
    const no_filter = getQueryValue(location, 'no_filter') || false;
    const groundTruthOnlyQuery = getQueryValue(location, 'groundTruth');

    const [user] = useZibi('user');

    const [data, s_data] = useState({});
    const [severity, s_severity] = useState(sev || "");
    const [groundOnlyTruth, s_groundOnlyTruth] = useState(groundTruthOnlyQuery || "");
    const [groundTruth, s_groundTruth] = useState("");
    const [status, s_status] = useState("");
    const [type, s_type] = useState("");

    const [currentPage, setCurrentPage] = useState(0);
    const [callingTheApi, setCallingTheApi] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(true);

    const eventName = "alerts-event";
    const userRole = user?.role?.[0];

    const [sentryRef] = useInfiniteScroll({
        callingTheApi,
        hasNextPage,
        onLoadMore: getAlerts,
    });

    useEffect(() => {
        register(eventName);
        window.addEventListener(eventName, onAlerts);
        return () => {
            unregister(eventName);
            window.removeEventListener(eventName, onAlerts);
        };
    }, []);

    const onAlerts = async (eventData) => {
        const {alertId} = eventData.detail;
        if (alertId) {
            getSingleAlert(alertId);
        }
    };

    const goToAlert = (e, alertId) => {
        e.stopPropagation();
        navigate(`/alert?alertId=${alertId}`);
    };

    const getSingleAlert = async (alertId) => {
        const dataRes = await api({type: 'getAlerts', data: {isSingle: true, alertId}});
        const alertush = dataRes?.alerts?.[0];
        if (alertush) {
            s_data(prevState => {
                const tempData = {...prevState};
                if (alertush.status === 'PENDING') {
                    tempData.alerts.unshift(alertush);
                    return tempData;
                } else {

                    tempData.alerts = tempData.alerts.map(aler => {
                        if (aler._id === alertId) {
                            return alertush;
                        }
                        return aler;
                    });
                    return tempData;
                }
            });
        }
    };

    async function getAlerts(page) {
        setCallingTheApi(true);
        let ppage = page;
        if (ppage === 'undefined') {
            ppage = currentPage || 0;
        }
        const dataBody = {
            limit: 40,
            page: ppage
        };
        if (severity) {
            dataBody.severity = severity;
        }
        if (status) {
            dataBody.status = status;
        }
        if (type) {
            dataBody.eventEntity = type;
        }

        if (groundOnlyTruth) {
            dataBody.groundOnlyTruth = true;

            if (groundTruth) {
                if (groundTruth === 'VALID') {
                    dataBody.groundTruth = 1;
                }
                if (groundTruth === 'INVALID') {
                    dataBody.groundTruth = 2;
                }
            }
        }

        if (user.siteId) {
            dataBody.siteId = user.siteId;
        }

        const dataRes = await api({type: 'getAlerts', data: dataBody});

        let tempDataAlerts = data?.alerts || [];
        if (ppage === 0) {
            tempDataAlerts = [];
        }
        const tempAlerts = [...tempDataAlerts, ...dataRes.alerts];
        dataRes.alerts = tempAlerts;

        s_data(dataRes);
        setCurrentPage(ppage + 1);
        setCallingTheApi(false);
        if (tempAlerts?.length < 40) {
            setHasNextPage(false);
        }
    }

    useEffect(() => {
        if (sev) {
            s_severity(sev);
        } else if (severity && !sev) {
            s_severity("");
        }
    }, [sev]);

    useEffect(() => {
        if (groundTruthOnlyQuery) {
            s_groundOnlyTruth(groundTruthOnlyQuery);
        } else if (groundOnlyTruth && !groundTruthOnlyQuery) {
            s_groundOnlyTruth("");
        }
    }, [groundTruthOnlyQuery]);

    useEffect(() => {
        setCurrentPage(0);
        setHasNextPage(true);
        getAlerts(0);
    }, [status, severity, groundOnlyTruth, groundTruth, type]);

    const handleStatusChange = async (event, alert) => {
        await api({
            type: 'editAlert', data: {
                _id: alert._id, status: event.target.value
            }
        });
        getSingleAlert(alert._id);
    };

    const selectorChange = (e, type) => {
        const val = e.target.value;
        let valToUpdate = val;
        if (val === 'All') {
            valToUpdate = '';
        }
        switch (type) {
            case 'status':
                s_status(valToUpdate);
                break;
            case 'type':
                s_type(valToUpdate);
                break;
            case 'severity':
                s_severity(valToUpdate);
                break;
            case 'groundTruth':
                s_groundTruth(val);
                break;
        }
    };

    const alertsExist = !!data?.alerts?.length;

    const isSeverity = !groundOnlyTruth;
    const isGroundTruth = !!groundOnlyTruth;

    let title = 'All';
    if (isGroundTruth) {
        title = 'Ground truth';
    }
    if (sev === 'CRITICAL') {
        title = 'Critical';
    }

    return (
        <div style={{height: '100%', overflowY: 'scroll', padding: 20}}>
            <TitleWrapperStyled>
                <PageTitle>
                    <Icn>errorOutlineIcon</Icn> <Tx>page.alerts.title</Tx>
                    <span className="title-addition">{title}</span>
                </PageTitle>
            </TitleWrapperStyled>
            <WrapperStyled>
                <ActionsWrapperStyled>
                    <h2><Tx>page.alerts.listOfAlerts</Tx></h2>
                    {!no_filter && (<ActionItemStyled>
                            {isSeverity && (
                                <>
                                    <FormControl>
                                        <InputLabel id="severity-id">Severity</InputLabel>
                                        <Select
                                            labelId="severity-id-label"
                                            id="severity-id"
                                            value={severity}
                                            label="Severity"
                                            onChange={(e) => {
                                                selectorChange(e, 'severity');
                                            }}
                                        >
                                            <MenuItem value="All">All</MenuItem>
                                            {Object.values(ALERT_MAP.severities).map(item => {
                                                return (
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                    <FormControl>
                                        <InputLabel id="status-id">Status</InputLabel>
                                        <Select
                                            labelId="status-id-label"
                                            id="status-id"
                                            value={status}
                                            label="Status"
                                            onChange={(e) => {
                                                selectorChange(e, 'status');
                                            }}
                                        >
                                            <MenuItem value="All">All</MenuItem>
                                            {Object.values(ALERT_MAP.statuses).map(item => {
                                                return (
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                    <FormControl>
                                        <InputLabel id="type-id">Type</InputLabel>
                                        <Select
                                            labelId="type-id-label"
                                            id="type-id"
                                            value={type}
                                            label="Type"
                                            onChange={(e) => {
                                                selectorChange(e, 'type');
                                            }}
                                        >
                                            <MenuItem value="All">All</MenuItem>
                                            {Object.values(ALERT_MAP.eventEntitys).map(item => {
                                                return (
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </>
                            )}
                            {isGroundTruth && (
                                <>
                                    <FormControl>
                                        <InputLabel id="groundTruth-id">Ground Truth</InputLabel>
                                        <Select
                                            labelId="groundTruth-id-label"
                                            id="groundTruth-id"
                                            value={groundTruth}
                                            label="Ground Truth"
                                            onChange={(e) => {
                                                selectorChange(e, 'groundTruth');
                                            }}
                                        >
                                            <MenuItem value="All">All</MenuItem>
                                            {GROUND_TRUTH_DATA.map(item => {
                                                return (
                                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </>
                            )}
                        </ActionItemStyled>
                    )}
                </ActionsWrapperStyled>


                <ListWrapperStyled>
                    {alertsExist && (
                        <>
                            {userRole === USER_TYPES.ALERT_HANDLER && (
                                <AlertManager
                                    data={data}
                                    goToAlert={goToAlert}
                                    handleStatusChange={handleStatusChange}
                                />
                            )}

                            {userRole === USER_TYPES.SITE_ADMIN && (
                                <SiteAdminAlerts
                                    data={data}
                                    goToAlert={goToAlert}
                                    handleStatusChange={handleStatusChange}
                                />
                            )}
                        </>
                    )}

                    {!alertsExist && (
                        <div>No Alerts</div>
                    )}
                    <div style={{position: 'relative', top: '-25vh'}} ref={sentryRef}/>
                </ListWrapperStyled>
            </WrapperStyled>
        </div>
    );
};

export default AlertsPage;